/**
 * Gössl Newsletter Form — Brevo double-opt-in via Xano
 *
 * Attaches to any form marked `data-newsletter-form` and submits the email
 * via AJAX to the Xano endpoint /newsletter/subscribe, which then calls
 * Brevo's doubleOptinConfirmation endpoint.
 *
 * Brevo sends the confirmation email. User clicks → added to list 4.
 *
 * Form markup contract:
 *   <form data-newsletter-form data-newsletter-source="footer">
 *     <input type="email" name="email" required>
 *     <button type="submit">…</button>
 *     <span data-newsletter-status></span>
 *   </form>
 *
 * Strings come from window.GoesslNewsletterStrings (set inline by theme).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://gwandl-mcp.g-ssl.workers.dev/newsletter/subscribe';
  var DISMISS_KEY = 'goessl_newsletter_dismissed';
  var SUBMITTED_KEY = 'goessl_newsletter_submitted';

  var strings = (window.GoesslNewsletterStrings || {
    submitting: 'Wird gesendet…',
    success: 'Bitte bestätige deine Anmeldung per E-Mail.',
    error_generic: 'Da ist etwas schiefgelaufen. Bitte versuche es später erneut.',
    error_invalid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    error_network: 'Keine Verbindung. Bitte prüfe deine Internetverbindung.',
  });

  function setStatus(form, msg, isError) {
    var el = form.querySelector('[data-newsletter-status]');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-error', !!isError);
    el.classList.toggle('is-success', !!(msg && !isError));
  }

  function setBusy(form, busy) {
    form.classList.toggle('is-submitting', busy);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = busy;
  }

  function markSubmitted(email) {
    try {
      localStorage.setItem(SUBMITTED_KEY, JSON.stringify({
        email: email,
        at: Date.now(),
      }));
    } catch (e) {}
  }

  function wasRecentlySubmitted() {
    try {
      var raw = localStorage.getItem(SUBMITTED_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      // 7 days
      return (Date.now() - data.at) < 7 * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  async function submit(form) {
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var source = form.dataset.newsletterSource || 'unknown';

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus(form, strings.error_invalid_email, true);
      return;
    }

    setBusy(form, true);
    setStatus(form, strings.submitting, false);

    try {
      var res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: source }),
      });

      var data = null;
      try { data = await res.json(); } catch (e) {}

      if (res.ok && (!data || data.ok !== false)) {
        setStatus(form, (data && data.message) || strings.success, false);
        markSubmitted(email);
        if (emailInput) emailInput.value = '';
        form.dispatchEvent(new CustomEvent('newsletter:success', { bubbles: true, detail: { email: email, source: source } }));
      } else {
        var msg = (data && data.error === 'invalid_email') ? strings.error_invalid_email : strings.error_generic;
        setStatus(form, msg, true);
      }
    } catch (err) {
      setStatus(form, strings.error_network, true);
    } finally {
      setBusy(form, false);
    }
  }

  function bind(form) {
    if (form._goesslNewsletterBound) return;
    form._goesslNewsletterBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit(form);
    });
  }

  function init() {
    document.querySelectorAll('form[data-newsletter-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose tiny helper for the popup section
  window.GoesslNewsletter = {
    wasRecentlySubmitted: wasRecentlySubmitted,
    DISMISS_KEY: DISMISS_KEY,
    SUBMITTED_KEY: SUBMITTED_KEY,
  };
})();
